import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import config from '../../config'
import * as Api from '../../common/Api';
import {LIST_STATUSES} from "../../common/metadata/ListStatuses";

const initialState = {
    loading: false,
    reload: false,
    alertMessage: undefined,
    successMessage: undefined,
    adminList: null,
    adminListMatchReport: null,
};

export const getAdminListMatchReportById = createAsyncThunk('matchListReport/get-managed-list-match-report', async (id) => {
    console.log(`${config.services.ATLAS.apiUrl}/lists/${id}/match-report`);
    console.log(id);
    const adminListMatchReport = await Api.get(true, `${config.services.ATLAS.apiUrl}/managed-lists/${id}/match-report`);
    return adminListMatchReport;
});


export const getMatchListById = createAsyncThunk('matchListReport/get-by-id', async (id) => {
    const URL = `${config.services.ATLAS.apiUrl}/managed-lists/${id}`;
    const adminList = await Api.get(true, URL);
    return adminList;
});

export const createMatchReport = createAsyncThunk('matchListReport/createMatchReport',
    async ({id}) => {
        const GET_URL = `${config.services.ATLAS.apiUrl}/managed-list-matches`;
        const DOWNLOAD_LIST = `${GET_URL}/${id}/create-match-report`;
        return await Api.get(true,
            DOWNLOAD_LIST,
            {
                options: {
                },
                data: {
                }
            }
        );
    });

const listMatchReportSlice = createSlice({
    name: 'adminListMatchReportSlice', initialState,
    reducers: {
        clearState: (state) => {
            state.loading = false;
            state.reload = false;
            state.alertMessage = undefined;
            state.successMessage = undefined;
            state.adminList = null;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMatchListById.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getMatchListById.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.adminList = action.payload;
                }
            })
            .addCase(getMatchListById.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to retrieve managed list';
            })
            .addCase(createMatchReport.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
                state.adminListMatchReport = undefined;
            })
            .addCase(createMatchReport.fulfilled, (state, action) => {
                state.alertMessage = undefined;
                state.successMessage = undefined;
                state.loading = false;
                if (action.payload) {
                    state.adminListMatchReport = action.payload;
                }
            })
            .addCase(createMatchReport.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to create match report for this list';
                state.successMessage = undefined;
                state.adminListMatchReport = undefined;
            })
            .addCase(getAdminListMatchReportById.pending, (state, action) => {
                state.loading = true;
                state.successMessage = undefined;
                state.alertMessage = undefined;
            })
            .addCase(getAdminListMatchReportById.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.adminListMatchReport = action.payload;
                }
            })
            .addCase(getAdminListMatchReportById.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to retrieve enrichment report.';
                state.adminListMatchReport = null;
            });
    }
});

export const { clearState } = listMatchReportSlice.actions;
export default listMatchReportSlice.reducer;
